export default __webpack_public_path__ + "static/media/talismanWalletIcon.30f7c325.svg";